import { createContext } from "react";
import type { UiConfig } from "@/types/api.types";

// Fail-closed defaults: every flag off until the server says otherwise, so a
// slow or failed /config/ui fetch hides in-progress features rather than
// flashing them on. Mirrors the old build-time default-OFF behavior.
export const DEFAULT_FEATURE_FLAGS: UiConfig = {
  show_conversation_grades: false,
  show_eval_runs: false,
  show_eval_suggestions: false,
  show_prompt_lab: false,
};

export const FeatureFlagsContext = createContext<UiConfig>(
  DEFAULT_FEATURE_FLAGS,
);
